import React, { useEffect } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';


const TcProfilemain = () => {

 

  
  /*----Function open form----*/

 function openForm(e)

 {
  e.preventDefault();
 document.getElementById("tcaddForm").style.display = "block";

  }

/*----Function close form----*/
function closeForm()

  {

    //window.location.reload();

     document.getElementById("tcaddForm").style.display = "none";

   }


  function handleSubmit(e){
e.preventDefault();

    var password = document.getElementById("psw").value;
    var npassword = document.getElementById("npsw").value;
    var cpassword = document.getElementById("cpsw").value;
   
    if(!password){
      document.getElementById("error").innerHTML = "Enter Current Password";
    
    }
    else{
      document.getElementById("error").innerHTML = "";
    }
   
    if(!npassword){
      document.getElementById("nerror").innerHTML = "Enter New Password";
      document.getElementById("nerror1").innerHTML = "";
      document.getElementById('nerror2').innerHTML="";
     
     }
     else if(!/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(npassword)){
      document.getElementById("nerror1").innerHTML = " Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
      document.getElementById("nerror").innerHTML = "";
      document.getElementById('nerror2').innerHTML="";
  }
 
  else if  (password==npassword){
    document.getElementById('nerror2').innerHTML="This is Your Current Password";
  document.getElementById('nerror1').innerHTML=" ";
   document.getElementById('nerror').innerHTML=" ";
  }
   else{
    document.getElementById("nerror2").innerHTML = "";
    document.getElementById("nerror").innerHTML = "";
    document.getElementById('nerror1').innerHTML="";
  }
   if(!cpassword){
   
    document.getElementById("cerror").innerHTML = "Enter Confirm Password";
  }
  else if(npassword != cpassword){
    document.getElementById("cerror").innerHTML = "";
    document.getElementById("cerror1").innerHTML = "Passwords Not Match";
  }
 
 
    else  {
      document.getElementById("cerror1").innerHTML = "";
      document.getElementById("psw").value = "";
      document.getElementById("npsw").value = "";
      document.getElementById("cpsw").value = "";

 
  const body ={
  currentPassword: password,
  newPassword:npassword
}


let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));


  axios({

    method: "POST",
    //url :`${BASE_URL}/Authenticate/CHANGE-PASSWORD`,
    url: "https://localhost:44312/Api/Authenticate/ChangePassword",
    data:body,
    headers: {
      "Content-Type": "application/json" ,
      'Authorization':bearer
    }
  
  })
 
  .then((response) =>{
    console.log(response.data);
  
     if(response.data.status === "Success"){
       
          document.getElementById('success-notify').style.display = "block"
          closeForm()

           setTimeout(()=>{
             document.getElementById('success-notify').style.display = "none"
             window.location.href="/#/"
           },1000)
        }
     
    })
    .catch(error => {
      console.log(error);
   
  document.getElementById('error-notify').style.display = "block"
  setTimeout(()=>{
    document.getElementById('error-notify').style.display = "none"
  },1000)

  
    })
 
    }   
}

 
function handlechange(event){
  event.preventDefault()
  var password = document.getElementById("psw").value;
    var npassword = document.getElementById("npsw").value;
    var cpassword = document.getElementById("cpsw").value;
    if(!password){
      document.getElementById("error").innerHTML = "Enter Current Password";
    
    }
    else{
      document.getElementById("error").innerHTML = "";
    }
   
     if(!npassword){
      document.getElementById("nerror").innerHTML = "Enter New Password";
      document.getElementById("nerror1").innerHTML = "";
      document.getElementById('nerror2').innerHTML="";
     
     }
     else if(!/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(npassword)){
      document.getElementById("nerror1").innerHTML = " Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
      document.getElementById("nerror").innerHTML = "";
      document.getElementById('nerror2').innerHTML="";
  }
 
  else if  (password==npassword){
    document.getElementById('nerror2').innerHTML="This is Your Current Password";
  document.getElementById('nerror1').innerHTML=" ";
   document.getElementById('nerror').innerHTML=" ";
  }
   else{
    document.getElementById("nerror2").innerHTML = "";
    document.getElementById("nerror").innerHTML = "";
    document.getElementById('nerror1').innerHTML="";
  }
   if(!cpassword){
    document.getElementById("cerror1").innerHTML = "";
    document.getElementById("cerror").innerHTML = "Enter Confirm Password";
  }
  else if(npassword.length !== cpassword.length){
    document.getElementById("cerror").innerHTML = "";
    document.getElementById("cerror1").innerHTML = "Passwords Not Match";
  }
  else {
    document.getElementById("cerror").innerHTML = "";
    document.getElementById("cerror1").innerHTML = "";
    
  }
}

function hideA(){
 
  var x = document.getElementById("psw");
  var eye = document.getElementById("eyeA");

  if(x.type === "password"){
 x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye") 
 }
  else{
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")
  }
 }

 function hideB(){

  var x = document.getElementById("npsw");
  var eye = document.getElementById("eyeB");
  if(x.type === "password"){
 x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
   
 }
  else{
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")

  }
 }

 function hideC(){

  var x = document.getElementById("cpsw");

  var eye = document.getElementById("eyeC");

  if(x.type === "password"){
 x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
   
 }
  else{
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")

  }
 }

  

   useEffect(()=>{
     document.getElementById("Uname").innerHTML=localStorage.getItem('username');
     document.getElementById("email").innerHTML=localStorage.getItem('email');
   });

  return (
    <>  
    <div className='TC-addmain'>   
    <div className="TC-addgrid-layout">
    
  <div className="TC-addmain-top">
   
  <div className='TC-addmain-back'>
    <Link to='/Thats Cool'><i className="fa-sharp fa-solid fa-backward" ></i></Link>
    </div> 
    <span> Welcome </span>
    </div>
    </div>
    
    <div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Password&nbsp; Change</p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>

<div className='TCpopfade' id='error-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p>Password&nbsp; Change </p>
      <h6 class="notif-title">Failed !&nbsp;<i class="fa-solid fa-thumbs-down" style={{fontSize:'25px'}}></i></h6>
   </section>
    </div>
  </div>
</div>

  
    <div>
    <div className='P-container'></div>
  <div class="wrapper fadeInDown">      
  <div id="formContent">
    <form className='form-input'>
  
      <span type="text" id="login"  name="Email" readOnly placeholder="Email"><span id="Uname"></span></span>
      <span type="text" id="password" name="psw" readOnly placeholder="password"><span id="email"></span></span>
  <div className='btn-div'>
      <button type='submit' class="fadeIn fourth"  onClick={openForm}>Change Password</button>     
      </div>     
    </form>

 {/* ---  Change password form--- */}
   
    <div className='TCpopfade' id="tcaddForm">
   
  <div className="modal-dialog" role="document">
    <div className="modal-contentt">
  
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Reset Password</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      <form>
     
      <div className="modal-bodyy mx-3">      
      <div className="md-form mb-5">
     
            <input type="password" id="psw"className="form-control validate" placeholder="Current Password" onKeyUp={handlechange} />
            <div className='TC-eyeicon_A'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hideA} id="eyeA"></i></div> 
            <span id="error" className='TcProfile-error'></span>
            <span id="error1" className='TcProfile-error'></span> 
            </div>
            <div className="md-form mb-5">
          
        <div className='TC-eyeicon_B'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hideB} id="eyeB"></i></div> 
        
    <input type="password" id="npsw"className="form-control validate" placeholder=" New Password"  onKeyUp={handlechange}/>
    
    <span id="nerror" className='TcProfile-error'></span>
    <span id="nerror1" className='TcProfile-error'></span>
    <span id="nerror2" className='TcProfile-error'></span>
      
   </div>
   <span id="nerror2" ></span>
    <div className="md-form mb-5">
      
    <input type="password"  id="cpsw"className="form-control validate" placeholder="Confirm Password"  onKeyUp={handlechange}/> 
    <div className='TC-eyeicon_C'><i class="fa fa-eye-slash" aria-hidden="true" onClick={hideC} id="eyeC"></i></div>
    <span id="cerror" className='TcProfile-error'></span>
        <span id="cerror1" className='TcProfile-error'></span>
    </div>
   </div>
  
  <div  className="md-form mb-4">
    <button type="button" name="next"  className="action-button" onClick={handleSubmit}>Reset</button>
     </div> 
</form>
</div>
</div>
</div>
  </div>
</div>
</div>
</div>
  
    </>
  )
}

export default TcProfilemain;
